import { render, staticRenderFns } from "./QueueRow.vue?vue&type=template&id=32f21e33&scoped=true"
import script from "./QueueRow.vue?vue&type=script&lang=js"
export * from "./QueueRow.vue?vue&type=script&lang=js"
import style0 from "./QueueRow.vue?vue&type=style&index=0&id=32f21e33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f21e33",
  null
  
)

export default component.exports